import Configuration from "../Config/Config";
import { createClient } from "urql";

const graphQLClient = new createClient({
  url: Configuration.urlGraphQl,
  fetchOptions: () => ({
    headers: { "x-api-key": Configuration.X_API_KEY },
  }),
});

export default graphQLClient;
